import React, { useState, useRef, useEffect } from "react";
import Menu from "./Menu/Menu";
import Burger from "./Menu/Burger";
import { ThemeProvider } from "styled-components";
import { GlobalStyles } from "./Menu/global";
import { theme } from ".//Menu/theme";
import { Link } from 'react-router-dom'
import * as Scroll from "react-scroll";
import {
  faInstagram,
  faFacebookF,
  faLinkedinIn,
  faApple,
  faGooglePlay,
} from "@fortawesome/free-brands-svg-icons";
import Fade from "react-reveal/Fade";
import { Helmet } from "react-helmet";

import { useHistory } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload, faChevronRight } from "@fortawesome/free-solid-svg-icons";

function Privacy() {


  var Element = Scroll.Element;
  var scroller = Scroll.scroller;







  const [open, setOpen] = useState(false);
  const history = useHistory();

  const [sticky, setSticky] = useState({ isSticky: false, offset: 0 });
  const headerRef = useRef(null);

  // handle scroll event

  const handleScroll = (elTopOffset, elHeight) => {
    if (window.pageYOffset > elTopOffset + elHeight) {
      setSticky({ isSticky: true, offset: elHeight });
    } else {
      setSticky({ isSticky: false, offset: 0 });
    }
  };
 // router
 function handleClick(e, path) {
  e.preventDefault();
  window.open(path, '_blank') 
}
  // add/remove scroll event listener
  useEffect(() => {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0;
    
    var header = headerRef.current.getBoundingClientRect();
    const handleScrollEvent = () => {
      handleScroll(header.top, header.height);
    };

    window.addEventListener("scroll", handleScrollEvent);

    return () => {
      window.removeEventListener("scroll", handleScrollEvent);
    };
  }, []);
  return (
    <div>
      <Helmet>
                <meta charSet="utf-8" />
                <title>Nos-Wazeefa privacy</title>
                <link
                  rel="canonical"
                  href="http://noswazeefa.net/privacy_ar"
                />
            </Helmet>

<ThemeProvider theme={theme}>
      <>
        <GlobalStyles />
    <div>
      <div className='arabic privacy'>
        <div id="menu_mobile">
          <Burger open={open} setOpen={setOpen} />
          <Menu open={open} setOpen={setOpen} />
        </div>
        <header id="Home">
          <nav
            id="sticky-header"
            className='sticky privacy'
            ref={headerRef}
          >
            <div>
              <div className="logo">
                <img src={require("../assets/images/logo.png")} alt="logo" />
              </div>
              <div className="list">
                <ul>
                  <li>
                    <a
                      onClick={() => history.push('/ar#Home')}
                    >
                      الرئيسية
                      </a>
                  </li>
                  <li>
                    <a
                      onClick={() => history.push('/ar#Features')}

                    >
                      حمل التطبيق
                      </a>

                  </li>

                  <li>
                    <a
                      onClick={() => history.push('/ar#Company')}

                    >
                      الشركات
                      </a>
                  </li>
                  <li>
                    <a


                    >
                      السياسه و الخصوصيه
                      </a>

                  </li>
                  <li>
                    <a
                      onClick={() => history.push('/ar#Contact')}

                    >


                      تواصل معنا
                      </a>
                  </li>
                  <li className='tomainPage'>
                    <Link  rel="canonical" to='/' className="ar" >

                      الانجليزيه
                      </Link>
                  </li>

                </ul>
              </div>
            </div>
          </nav>
        </header>
        <div className="privacy">

          <section className="hdr">

            <h2>السياسه و الخصوصيه</h2>
          </section>
          <main>
            <section >
              <ul>
                <li>
                  <strong>نص وظيفه</strong> بحماية خصوصية مستخدميه. يعتبر هدفنا هو تزويدكم بتجربة إلكترونية آمنة وضمان خصوصية أي معلومات مقدمة لنا تقومون باستخدامها | بإفصاحها للأغراض المذكورة بالأسفل فقط
  </li>
                <li>
                  <span> <Link  rel="canonical" to='/ar'>كموقع </Link></span>||  <span> <a href="https://play.google.com/store/apps/details?id=com.joe13th.noswazeefa&hl=en">تطبيق</a> </span>لتوظيف، سيطلب  <strong> نص وظيفه </strong>من الباحثين عن العمل وأصحاب العمل تزويده بأي معلومات تتعلق بالبحث عن الوظيفة | الشخص المطلوب توظيفه حتى تجري عملية البحث بفاعلية أفضل
  </li>
              </ul>


            </section>
            <section>
              <h4>التسجيل</h4>
              <ul>
                <li>  للمشاركة بشكل كامل في قاعدة بيانات الباحثين عن العمل، يجب أن تسجل عضويتك في  <span> <Link  rel="canonical" to='/ar'>موقع </Link></span>||  <span> <a href="https://play.google.com/store/apps/details?id=com.joe13th.noswazeefa&hl=en">تطبيق</a> </span> <strong>نص وظيفة</strong></li>
                <li>للتسجيل، سنطلب من الشركات والباحثين عن العمل تزويد معلومات اتصالهم. أيضا، سيطلب من الشركات تزويد معلومات عنها</li>
                <li>إن    <strong>     نص وظيفه </strong>هي المالك الوحيد للمعلومات المجموعة في صفحات التسجيل ولن يفصح عن هذه المعلومات لأي طرف خارج شركة الحلفاء الوطنيون للتقنية المالك ل نص وظيفة إن معلومات اتصالك مثل اسمك وبريدك الإلكتروني قد تستخدم للاتصال بك لإعلامك بأي مميزات/خدمات يقدمها      <span> <Link to='/ar'>موقعنا </Link></span>||  <span> <a href="https://play.google.com/store/apps/details?id=com.joe13th.noswazeefa&hl=en">تطبيقنا</a> </span>   والتي قد تكون مفيدة  </li>
                <li> إن هدفنا هو تزويد مستخدمينا بخدمة رائعة تترك أثرها عليهم في كل مرة يدخلون فيها على     <span> <Link rel="canonical" to='/ar'>موقع </Link></span>||  <span> <a href="https://play.google.com/store/apps/details?id=com.joe13th.noswazeefa&hl=en">تطبيق</a> </span><strong> نص وظيفة </strong> الإلكتروني ولهذا السبب ندعوكم إلى إلقاء نظرة على الوظائف وغيرها من مرافق والتي ستعود عليكم بالفائدة في مهنتكم | نشاطاتكم اليومية</li>


              </ul>

            </section>


            <section>
              <h4>السير الذاتية</h4>
              <p> يوجد طريقتين يمكن للباحثين عن العمل نشر سيرهم الذاتية بها في قاعدة البيانات : </p>
              <ul>
            
                <li>   يمكن للباحثين عن العمل تعبئة الخانات المتروكة لهم عن معلوماتهم الشخصية والدراسة والخبرات وغيرها. كما يمكنهم تحميل سيرتهم الذاتية مباشرة على  <span> <Link  rel="canonical" to='/ar'>موقع </Link></span>||  <span> <a href="https://play.google.com/store/apps/details?id=com.joe13th.noswazeefa&hl=en">تطبيق</a> </span> </li>
            
            <li>لا يتحمل <strong> نص وظيفة </strong>  أي مسؤولية تجاه خصوصية النسخ التي يتم الحصول عليها من قبل مسؤولو التوظيف في الشركات والتي يتم الاحتفاظ بها في ملفات الشركة وقاعدة بيانتها الخاصة ، تستطيع أن تجري التغيرات/التعديلات على سيرتك الذاتية في أي وقت تريد كما تستطيع أن تقوم بحذف السير الذاتية من قاعدة بياناتنا في أي وقت تريد</li>
            
              </ul>
            </section>
            <section>
              <h4>الإعلانات الوظيفية</h4>
              <ul>
                <li> 
                سيطلب من الشركات أن تقدم معلومات اتصال مفصلة بالإضافة إلى تقديم معلومات عن متطلبات المنصب الذي تود إعلانه. جميع هذه المعلومات تكون مقدمة طوعا. يمكن إظهار تفاصيل الوظيفة لأي شخص من الباحثين عن العمل المسجلين لدينا. يستطيع الباحثون عن العمل أن يشاهدوا الوظيفة المعلنة دون الاطلاع على معلومات الاتصال. ستحجب الشركات اسمها كوسيلة إضافية لحماية الخصوصية عند عرض إعلاناتها على الموقع. عندها ستضمن الشركة خصوصيتها بينما يتقدم الباحثون عن العمل لإعلانها ، تستطيع أن تغير | تعدل | تحذف إي من المعلومات التي قمت بتزويدها في أي وقت من الأوقات
                  </li>
                  </ul>
                  </section>
                  <section>

                    <h4>صفحتك الخاصة</h4>
                    <ul>
                      <li> 
                         سيخصص لكل باحث عن العمل ولكل صاحب عمل مسجل في<span> <Link to='/ar'>موقع </Link></span>||  <span> <a href="https://play.google.com/store/apps/details?id=com.joe13th.noswazeefa&hl=en">تطبيق</a> </span> صفحة خاصة تمكنه من إدارة | توثيق عملية البحث عن العمل أو الموظفين</li>
                
                
                    </ul>
                    <p>** سيتابع <strong> نص وظيفة </strong>   التزامه في حماية خصوصية مستخدميه ومضاعفتها. سنطلعكم باستمرار على جميع التغيرات | التعزيزات في ممارساتنا لحماية الخصوصية </p>
                  </section>
          </main>
          <footer>
            <div>
            <Fade bottom>
              <h4>
              حمل تطبيقنا الآن 
             <br /> للحصول على فرص غير متناهية 
              </h4>
              </Fade>
              <div className="buttons apple_google">
                <button
                  onClick={(e) =>
                    handleClick(
                      e,
                      "https://play.google.com/store/apps/details?id=com.joe13th.noswazeefa&hl=en"
                    )
                  }
                >
            
                                    <img src={require("../assets/images/google.png")} alt=''/>


                </button>
                <button
                  onClick={(e) =>
                    handleClick(
                      e,
                      "https://apps.apple.com/gb/app/noswazeefa/id1491881612?l=nb"
                    )
                  }
                >

                  <img src={require("../assets/images/apple.png")} alt=''/>

                </button>
              </div>
            </div>

            <div className="bot_page">
              <p>
                © كل الحقوق محفوظه 2020| 
               تم العمل بواسطه{" "}
                <span>
                  <a href="https://natsaudi.net/" target="_blank">NAT</a>
                </span>{" "}
                |  <Link to='privacy_ar'>السياسه و الخصوصيه</Link>
              </p>

              <div className="social_icons">
                <a href="https://www.instagram.com/noswazeefa/" target="_blank">
                  <FontAwesomeIcon icon={faInstagram} />
                </a>
                <a href="https://www.facebook.com/noswazeefasa/" target="_blank">
                  <FontAwesomeIcon icon={faFacebookF} />
                </a>
                <a href="https://www.linkedin.com/company/noswazeefa/?viewAsMember=true" target="_blank">
                  <FontAwesomeIcon icon={faLinkedinIn} />
                </a>
              </div>
            </div>
          </footer>
        </div>

      </div>
    </div>

</>
</ThemeProvider>


</div>
  )
}
export default Privacy; 